import React, { useEffect, useState, useRef } from 'react';
import logo0 from "../Images/logomsa0.png";
import { NavLink } from "react-router-dom";
import './Navbar.css';
import { useAuth } from '../../Outer/Context/AuthContext.js';

export default function Navbar() {
  const [showMenu, setShowMenu] = useState(false);
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const { currentUser, logout } = useAuth();
  let menuRef = useRef();
  let hamRef = useRef();


  useEffect(() => {
    const handler = (e) => {
      if (!menuRef.current.contains(e.target) && !hamRef.current.contains(e.target)) {
        setShowMenu(false);
      }
    };
    document.addEventListener("mousedown", handler);

    return () => {
      document.removeEventListener("mousedown", handler);
    };
  }, []);

  const handleLogout = () => {
    // const url = process.env.REACT_APP_API_URL + '/logout';
    // localStorage.removeItem('token');
    // updateUsername('Loading...');
    logout();
    // axios.get(url, { withCredentials: true })
    //   .then(response => {
    //     if (response.status === 200) {
    //       navigate('/');
    //     } else {
    //       console.error(`Error in logout: ${response}`);
    //     }
    //   })
    //   .catch(error => {
    //     console.error(`Error during logout: ${error}`);
    //     alert(JSON.stringify({ error }));
    //   });
  };

  return (
    <nav>
      <li className="home-top-logo_">
        <img className="home-top-logo" src={logo0} alt="Logo" />
      </li>
      <span className={showMenu ? "mobile-navigate home-top-navigate" : "home-top-navigate"} ref={menuRef}>
        <li>
          <NavLink exact="true" to="/" activeClassName="active-link" className="inactive-link">
            Home
          </NavLink>
        </li>
        <li>
          <NavLink to="/events" activeClassName="active-link" className="inactive-link">Events</NavLink>
        </li>
        <li>
          <NavLink to="/alumni" activeClassName="active-link" className="inactive-link">Alumni</NavLink>
        </li>
        <li className="home-top-profile">
          <div className="home-top-profile">
            <svg
              width="25"
              height="25"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{
                backgroundColor: "#fca201",
                borderRadius: "50%",
              }}
            >
              <path
                d="M10 0C11.3261 0 12.5979 0.526784 13.5355 1.46447C14.4732 2.40215 15 3.67392 15 5C15 6.32608 14.4732 7.59785 13.5355 8.53553C12.5979 9.47322 11.3261 10 10 10C8.67392 10 7.40215 9.47322 6.46447 8.53553C5.52678 7.59785 5 6.32608 5 5C5 3.67392 5.52678 2.40215 6.46447 1.46447C7.40215 0.526784 8.67392 0 10 0ZM10 12.5C15.525 12.5 20 14.7375 20 17.5V20H0V17.5C0 14.7375 4.475 12.5 10 12.5Z"
                fill="white"
              />
            </svg>
            <NavLink to="/profile">
              {currentUser?.username?.split('@')[0]?.charAt(0).toUpperCase() + currentUser?.username?.split('@')[0]?.slice(1).toLowerCase()}
            </NavLink>

            <NavLink to="#" onClick={() => setShowProfileMenu(!showProfileMenu)}>
              <svg width="25" height="15" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 0L5 5L10 0H0Z" fill="#DB9E30" />
              </svg>
            </NavLink>
          </div>
          <div className={showProfileMenu ? "home-top-profile-menu" : "home-top-profile-menu-hide"}>
            {/* <li>
              <NavLink to="/profile">Profile</NavLink>
            </li> */}
            <li>
              <NavLink to="#" onClick={handleLogout}>Logout</NavLink>
            </li>
          </div>
        </li>
      </span>
      <li className="home-top-ham" ref={hamRef}>
        <NavLink to="#" onClick={() => setShowMenu(!showMenu)}>
          {!showMenu ? (
            <svg
              width="23"
              height="20"
              viewBox="0 0 23 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 1H22M1 10H22M1 19H22"
                stroke="#DB9E30"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>) : 
            (<svg 
              xmlns="http://www.w3.org/2000/svg" 
              width="24" height="24" 
              viewBox="0 0 24 24"
            >
              <path 
                fill="currentColor" 
                d="M18.36 19.78L12 13.41l-6.36 6.37l-1.42-1.42L10.59 12L4.22 5.64l1.42-1.42L12 10.59l6.36-6.36l1.41 1.41L13.41 12l6.36 6.36z" /></svg>)}
        </NavLink>
      </li>
    </nav>
  );
}
